import { TextStyle, ViewStyle } from 'react-native';
import { theme } from '@sg/garnish';

// ─── Palettes ────────────────────────────────────────────────────────────────

export const backgroundPalettes: Record<ScanToPayPalette, ViewStyle> = {
  cream: {
    backgroundColor: theme.colors.CREAM,
  },
  'dark-kale': {
    backgroundColor: theme.colors.DARK_KALE,
  },
};

export const backgroundWithBorderPalettes: Record<ScanToPayPalette, ViewStyle> =
  {
    cream: {
      backgroundColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
    },
    'dark-kale': {
      borderWidth: 1,
      borderColor: theme.colors.CREAM,
      backgroundColor: theme.colors.DARK_KALE,
    },
  };

export const textPalettes: Record<ScanToPayPalette, TextStyle> = {
  cream: {
    color: theme.colors.KALE,
  },
  'dark-kale': {
    color: theme.colors.CREAM,
  },
};

export const iconPalettes: Record<ScanToPayPalette, string> = {
  cream: theme.colors.DARK_KALE,
  'dark-kale': theme.colors.CREAM,
};

export const lightIconPalettes: Record<ScanToPayPalette, string> = {
  cream: theme.colors.KALE,
  'dark-kale': theme.colors.CREAM,
};

export const iconBackgroundPalettes: Record<ScanToPayPalette, ViewStyle> = {
  cream: {
    backgroundColor: theme.colors.OPACITY.KALE.LIGHTEST,
  },
  'dark-kale': {
    backgroundColor: theme.colors.OPACITY.CREAM.DARK,
  },
};

// ─── Types ───────────────────────────────────────────────────────────────────

export type ScanToPayPalette = 'cream' | 'dark-kale';
